import React from 'react';
import { Box, FormControlLabel, Checkbox, TextField } from '@mui/material';

const PrecedingBehaviorSection = ({
  dataPoint,
  index,
  handleCheckboxChange,
  handleFieldChange,
}) => {
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint?.selectedOptions?.includes(
              'Add Preceding Behavior'
            )}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add Preceding Behavior'
          />
        }
        label='Add Preceding Behavior'
      />

      {dataPoint?.selectedOptions?.includes('Add Preceding Behavior') && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <TextField
              fullWidth
              margin='dense'
              value={dataPoint.precedingBehavior}
              className='input-height'
              onChange={(e) =>
                handleFieldChange(index, 'precedingBehavior', e.target.value)
              }
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default PrecedingBehaviorSection;
